// extracted by mini-css-extract-plugin
export default {"wrapper":"Pills_wrapper__yXkVh","selected":"Pills_selected__BXKG1","roundMinus":"Pills_roundMinus__MzrI9","minus":"Pills_minus__rBJDA"};